// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import TreePage from '@/features/energyxplorer/components/deepdive/TreePage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/energy-breakdown',
)({
  component: TreePage,
});
